import { PERMISSIONS } from "@/constants";
export default [
  {
    name: "companies",
    meta: {
      title: "Manage Companies",
      requiresAuth: true,
      permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
    },
    path: "/manage/companies",
    component: () => import("@/views/pages/companies"),
  },
  {
    name: "Company",
    meta: {
      title: "Company",
    },
    path:"/manage/company/:business_id",
    component: () => import("@/views/pages/companies/company.vue"),
  },
  {
    name: "CompanySettings",
    meta: {
      title: "Company - Settings",
    },
    path:"/manage/company/:business_id/settings",
    component: () => import("@/views/pages/companies/CompanySettings.vue"),
  },
];
